import React, { Component } from 'react';
import { connect } from 'react-redux';
import { func, string, bool, shape } from 'prop-types';

import { noScroll } from '~utils/scroll';
import { actionCreators as modalActions } from '~redux/Modal/actions';

import CustomModal from './layout';

class CustomModalContainer extends Component {
  state = { initDataModal: null };

  componentDidMount() {
    window.addEventListener('popstate', this.clearModals, false);
  }

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.setState({ initDataModal: this.props.dataModal });
      noScroll.on();
    }
    if (!this.props.isOpen && prevProps.isOpen) {
      noScroll.off();
    }
  }

  componentWillUnmount() {
    noScroll.off();
    window.removeEventListener('popstate', this.clearModals);
  }

  clearModals = () => {
    const { onClose, clearModals } = this.props;

    if (onClose) {
      onClose();
    }
    clearModals();
  };

  handleCloseModal = () => {
    const { modal, closeModal, onClose } = this.props;
    if (onClose) {
      onClose();
    }

    closeModal(modal);
  };

  handleAfterClose = () => {
    const { openModalAfterClose } = this.props;
    openModalAfterClose(this.state.initDataModal);
  };

  render() {
    const { children, ...props } = this.props;

    return (
      <CustomModal {...props} onRequestClose={this.handleCloseModal} onAfterClose={this.handleAfterClose}>
        {children}
      </CustomModal>
    );
  }
}

CustomModalContainer.propTypes = {
  clearModals: func.isRequired,
  closeModal: func.isRequired,
  modal: string.isRequired,
  acceptanceAction: func,
  dataModal: shape({}),
  isOpen: bool,
  openModalAfterClose: func,
  onClose: func
};

const mapStateToProps = (state, props) => ({
  dataModal: state.modal[props.modal]?.data
});

const mapDispatchToProps = dispatch => ({
  closeModal: modal => {
    dispatch(modalActions.closeModal(modal));
    dispatch(modalActions.closeModalWithData(modal));
  },
  openModalAfterClose: dataModal => {
    if (dataModal?.openModalAfterClose) {
      dispatch(modalActions.openModal(dataModal.openModalAfterClose));
    }
  },
  clearModals: () => dispatch(modalActions.clearModals())
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomModalContainer);
